import { FC, ReactNode } from 'react';

import classes from './CheckboxGroup.module.scss';

export interface CheckboxGroupProps {
  children?: ReactNode;
}

export const CheckboxGroup: FC<CheckboxGroupProps> = ({ children }) => {
  return <div className={classes.container}>{children}</div>;
};
